import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

(function () {
  var enterModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).enterModule;
  enterModule && enterModule(module);
})();

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

import React, { Component } from 'react';
import ReactScrolla from 'react-scrolla';
import { LogProvider } from './Providers/LogProvider.js';
import { LogTable } from './Components/LogTable.js';
import { ToggleEntry } from './Components/ToggleEntry.js';
import { LogUploader } from './Components/LogUploader.js';
import { SideBar, Separator, Settings } from 'oc-react-components';
import { LogFile } from './Providers/LogFile.js';
import styles from '../css/app.css';
export var App =
/*#__PURE__*/
function (_Component) {
  _inherits(App, _Component);

  function App(props) {
    var _this;

    _classCallCheck(this, App);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(App).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "state", {
      entries: [],
      loading: true,
      levels: [false, false, false, false, false],
      provider: null,
      relative: true,
      dateFormat: 'Y-m-d\TH:i:sO',
      live: false
    });

    _defineProperty(_assertThisInitialized(_this), "fetchNextPage", _.throttle(
    /*#__PURE__*/
    _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!_this.state.provider.hasMore) {
                _context.next = 6;
                break;
              }

              _this.setState({
                loading: true
              });

              _this.state.provider.limit += 25;
              _context.next = 5;
              return _this.state.provider.load();

            case 5:
              _this.setState({
                loading: false
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), 100));

    _defineProperty(_assertThisInitialized(_this), "onLogFile",
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(content) {
        var logFile;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                logFile = new LogFile(content);
                logFile.on('entries', function (entries) {
                  if (_this.state.provider === logFile) {
                    _this.setState({
                      entries: entries
                    });
                  }
                });
                _context2.prev = 2;
                _context2.next = 5;
                return logFile.loadEntries(0);

              case 5:
                _this.setState({
                  provider: logFile,
                  entries: []
                });

                logFile.load();
                _context2.next = 12;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](2);
                OC.Notification.show(t('logreader', 'Error parsing log'));

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 9]]);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());

    _defineProperty(_assertThisInitialized(_this), "setRelative", function (relative) {
      _this.setState({
        relative: relative
      });

      _this.saveRelative(relative);
    });

    _defineProperty(_assertThisInitialized(_this), "setLive", function (live) {
      _this.setState({
        live: live
      });

      if (live) {
        _this.logProvider.startPolling();
      } else {
        _this.logProvider.stopPolling();
      }

      _this.saveLive(live);
    });

    _defineProperty(_assertThisInitialized(_this), "handlePaste", function (event) {
      var data = event.clipboardData.getData('Text');

      if (!data) {
        data = event.clipboardData.getData('text/plain');
      }

      data = data.trim();

      if (data.indexOf('{') !== -1 && data.indexOf('}')) {
        _this.onLogFile(data);
      }
    });

    _this.logProvider = _this.props.logProvider;

    _this.logProvider.on('entries', function (entries) {
      if (_this.state.provider === _this.logProvider) {
        _this.setState({
          entries: entries
        });
      }
    });

    _this.saveRelative = _.debounce(_this.logProvider.setRelative, 100);
    _this.saveLive = _.debounce(_this.logProvider.setLive, 100);
    return _this;
  }

  _createClass(App, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3() {
        var levels, relative, dateFormat, live;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.logProvider.getLevels();

              case 2:
                levels = _context3.sent;
                _context3.next = 5;
                return this.logProvider.getRelative();

              case 5:
                relative = _context3.sent;
                _context3.next = 8;
                return this.logProvider.getDateFormat();

              case 8:
                dateFormat = _context3.sent;
                _context3.next = 11;
                return this.logProvider.getLive();

              case 11:
                live = _context3.sent;
                this.setState({
                  levels: levels,
                  relative: relative,
                  dateFormat: dateFormat,
                  live: live,
                  provider: this.logProvider
                });
                _context3.next = 15;
                return this.logProvider.load();

              case 15:
                if (live) {
                  this.logProvider.startPolling();
                }

                this.setState({
                  loading: false
                });
                document.addEventListener('paste', this.handlePaste);

              case 18:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "setLevel",
    value: function () {
      var _setLevel = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(level, newState) {
        var levels;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                levels = this.state.levels;
                levels[level] = newState;
                this.setState({
                  levels: levels
                });
                _context4.next = 5;
                return this.logProvider.setLevels(levels);

              case 5:
                this.logProvider.reset();
                this.logProvider.load();

              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function setLevel(_x2, _x3) {
        return _setLevel.apply(this, arguments);
      }

      return setLevel;
    }()
  }, {
    key: "getFilteredEntries",
    value: function getFilteredEntries() {
      var _this2 = this;

      return this.state.entries.filter(function (entry) {
        if (!entry.level && entry.level !== 0) {
          return true;
        }

        return _this2.state.levels[entry.level];
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var entries = this.getFilteredEntries();
      var filters = this.state.levels.map(function (status, level) {
        return React.createElement(ToggleEntry, {
          key: level,
          active: status,
          onChange: _this3.setLevel.bind(_this3, level)
        }, LogProvider.levels[level]);
      });
      var content;

      if (this.state.loading && entries.length < 1) {
        content = React.createElement("div", {
          className: "loading log-loading"
        });
      } else {
        content = React.createElement(ReactScrolla, {
          className: styles.scrollContainer,
          percentage: 85,
          onPercentage: this.fetchNextPage,
          isLoading: this.state.loading
        }, React.createElement("div", {
          className: styles.content
        }, React.createElement(LogTable, {
          inlineSettings: this.props.inlineSettings,
          levels: this.state.levels,
          setRelative: this.setRelative,
          setLevel: this.setLevel.bind(this),
          entries: entries,
          relative: this.state.relative,
          dateFormat: this.state.dateFormat,
          hidden: this.state.entries.length - entries.length,
          live: this.state.live,
          setLive: this.setLive.bind(this),
          onLogFile: this.onLogFile
        })));
      }

      return React.createElement("div", null, !this.props.inlineSettings ? React.createElement(SideBar, null, React.createElement(LogUploader, {
        onLogFile: this.onLogFile
      }), React.createElement(Separator, null), filters, React.createElement(Settings, null, React.createElement(ToggleEntry, {
        key: "relative",
        active: this.state.relative,
        onChange: this.setRelative
      }, "Relative Dates"))) : React.createElement("div", null), content);
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return App;
}(Component);
;

(function () {
  var reactHotLoader = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).default;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(App, "App", "/srv/http/owncloud/apps/logreader/js/App.js");
})();

;

(function () {
  var leaveModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).leaveModule;
  leaveModule && leaveModule(module);
})();